import React, { useEffect, useState } from 'react';
import M from 'materialize-css';
import moment from 'moment';
import * as yup from 'yup';
import { projectDetailsData, projectDetailsStore } from '../../stores/projectDetailsStore';
import { useFormik } from 'formik';
import ISO6391 from 'iso-639-1';
import './project-form.scss';
import { useHistory, useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import SaveButton from '../SaveButton/SaveButton';
import { instructionStoreData } from '../../stores/instructionsStore';
import { Select } from '@eyesee/eyesee-hub-npm-ui';

let instance: M.Datepicker;

const cellValidationSchema = yup.object({
    name: yup.string().required('Name is required'),
    end_date: yup.string().required('End date is required'),
    time: yup
        .string()
        .matches(/^\d+$/, 'The field should have digits only')
        .min(3, 'time should be of minimum 4 digits')
        .required('Time is required'),
    next_url: yup
        .string()
        .url()
        .required('Next url is required'),
});
const projectValidationSchema = yup.object({
    name: yup.string().required('Name is required'),
});
const ProjectForm = observer(
    ({ data, linkPath }: {  data: any; linkPath: { name: string; title: string } }) => {
        const [isCell, setIsCell] = useState<boolean>(false);
        const history = useHistory();
        let location = useLocation();
        let availableLangNameList = instructionStoreData.availableLangList && instructionStoreData.availableLangList.map((langCode) => ISO6391.getName(langCode));

        const formik = useFormik({
            initialValues: {
                name: data && data.name,
                end_date: data && data.end_date ? moment(data.end_date).format('DD.MM.YYYY.') : '',
                time: data?.time,
                next_url: data?.next_url,
                lang: data.lang ? ISO6391.getCode(data.lang) : ''
            },
            enableReinitialize: true,
            validationSchema: isCell ? cellValidationSchema : projectValidationSchema,
            onSubmit: async (values) => {
                projectDetailsStore.onSaveProject(isCell ? 'cell' : 'project');
                projectDetailsData.isDataSaved = true;
            },
        });

        let setDate = () => {
            let curr = moment(instance.date).format('DD.MM.YYYY.');
            let saved = moment(data.end_date).format('DD.MM.YYYY.');
            if (curr !== saved) {
              data.end_date = moment(instance.date).format('YYYY-MM-DD HH:mm:ss');
                // setData({ target: { name: 'end_date', value: moment(instance.date).format('YYYY-MM-DD HH:mm:ss') } });
              projectDetailsData.isDataSaved = false;
            }
        };

        useEffect(() => {
            if (location.pathname.includes('cell')) {
                setIsCell(true);
            } else {
                setIsCell(false);
            }
        }, [location.pathname]);

        useEffect(() => {
            // Fixme: useRef()
            var elem = document.querySelector('.datepicker');
            if (!elem) return;
            instance = M.Datepicker.init(elem as any, { format: 'dd.mm.yyyy.', firstDay: 1, onClose: setDate, minDate: new Date() });
            let date = moment(data && data.end_date).valueOf();
            instance.setDate(new Date(date));
        });

        const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            //  e.preventDefault()
            formik.handleChange(e);
            let value = e.target.name.includes('randomize') ? e.target.checked : e.target.value;
            if (e.target.name === 'randomize1' && value) {
                data['randomizeAll'] = !value;
            }
            if (e.target.name === 'randomizeAll' && value) {
                data['randomize1'] = !value;
            }
            if (e.target.name === 'lang') {
                data['lang'] = ISO6391.getCode(e.target.value);
            }else{
                data[e.target.name] = value;
            }

            projectDetailsData.isDataSaved = false;
        };

        const checkIsSavedAndRedirect = () => {
          if(!projectDetailsData.isDataSaved) {
            if(!window.confirm("Are you sure you want to leave without saving your work?")) {
              return;
            } 
            else {
              projectDetailsData.isDataSaved = true;
              history.push(linkPath.name)
            }
          } 
          else {
            projectDetailsData.isDataSaved = true;
            history.push(linkPath.name)
          }
        }

        return (
            <form className="project-form">
                <i
                    className="material-icons link pink-text tooltipped link-back"
                    title={`Back to ${linkPath.title}`}
                    onClick={() => checkIsSavedAndRedirect()}
                >
                    arrow_back
                </i>
                    <div className="input-field">
                        <input id="name" type="text" name="name" value={formik.values.name} onChange={onChange} />
                        <label className="active">Name</label>
                        <p className="error-msg">{formik.errors.name && formik.touched.name && formik.errors.name}</p>
                    </div>
                {isCell && (
                    <div className="input-field">
                        <input type="text" name="end_date" value={formik.values.end_date} onChange={onChange} className="datepicker" />
                        <label className={'active'}>End Date</label>
                        <p className="error-msg"> {formik.errors.end_date && formik.touched.end_date && formik.errors.end_date}</p>
                    </div>
                )}
                {isCell && (
                    <div className="input-field">
                        <input type="text" name="time" value={formik.values.time} onChange={onChange} />
                        <label className="active">Time</label>
                        <p className="error-msg"> {formik.errors.time && formik.touched.time && formik.errors.time}</p>
                    </div>
                )}
                {isCell && (
                    <div className="input-field">
                        <input type="text" name="next_url" value={formik.values.next_url} onChange={onChange} />
                        <label className="active">Next URL</label>
                        <p className="error-msg"> {formik.errors.next_url && formik.touched.next_url && formik.errors.next_url}</p>
                    </div>
                )}
                {isCell && (
                    <div className="checkbox-wrapper">
                        <p>Version:</p>
                        <div className="radio-btn-field">
                            <label className="active">
                                <input
                                    type="radio"
                                    className={data.version == 1 ? 'filled-in' : ''}
                                    name="version"
                                    checked={data.version == 1}
                                    value={1}
                                    onChange={onChange}
                                />
                                <span>V1</span>
                            </label>
                            <label className="active">
                                <input
                                    type="radio"
                                    className={data.version == 2 ? 'filled-in' : ''}
                                    name="version"
                                    checked={data.version == 2}
                                    value={2}
                                    onChange={onChange}
                                />
                                <span>V2</span>
                            </label>
                        </div>
                    </div>
                )}
                {isCell && (
                    <div className="checkbox-wrapper">
                        <p>Randomize:</p>
                        <div className="radio-btn-field">
                            <label className="active">
                                <input
                                    onChange={onChange}
                                    type="checkbox"
                                    className={data.randomize1 ? 'filled-in' : ''}
                                    name="randomize1"
                                    checked={data.randomize1}

                                    // onChange={onChange}
                                />
                                <span>Randomize one</span>
                            </label>
                            <label className="active">
                                <input
                                    onChange={onChange}
                                    type="checkbox"
                                    className={!!data.randomizeAll ? 'filled-in' : ''}
                                    name="randomizeAll"
                                    checked={data.randomizeAll}
                                    // onChange={onChange}
                                />
                                <span>Randomize all</span>
                            </label>
                        </div>
                    </div>
                )}
                {isCell && (
                    <div className="select-wrapper">
                        <p>Select Language:</p>
                        <Select name="lang" title="Select language" onChange={onChange} options={availableLangNameList} value={ISO6391.getName(data.lang)} />
                    </div>
                )}
                <SaveButton onClick={() => formik.handleSubmit()} title="Save Project" />
            </form>
        );
    }
);
export default ProjectForm;
